import { UUID } from 'types/shared/UUID';
import { ePartyPurpose } from '../../ui-toolkit/enums/ePartyPurpose';
import { ePartyType } from '../../ui-toolkit/enums/ePartyType';
import { IParty } from '../../ui-toolkit/orders/interfaces/IParty';
import { IPartyPerson } from '../../ui-toolkit/orders/interfaces/IPartyPerson';
import { IPartyEntity } from '../../ui-toolkit/orders/interfaces/IPartyEntity';

export interface ISigningPersonData {
  id: string;
  personId?: string;
  signatoryId?: string;
  ownerType?: ePartyPurpose;
  firstName: string;
  middleName?: string;
  lastName: string;
  email?: string;
  phoneNumber?: string;
  closingAppointmentId: UUID;
}

export const translatePartiesToPeople = (parties: IParty[]) => {
  const translatedPeople: any[] = [];
  parties
    .filter((p) => p.type === ePartyType.person)
    .map((p) => p as IPartyPerson)
    .forEach((p) => {
      const translation = {
        personId: p.id,
        firstName: p.first_name,
        middleName: p.middle_name,
        lastName: p.last_name,
        email: p.email,
        phoneNumber: p.phone_number,
      };
      translatedPeople.push(translation);
    });
  parties
    .filter((p) => p.type === ePartyType.entity)
    .map((p) => p as IPartyEntity)
    .map((p) => p.signatories)
    .reduce((p, c) => [...p, ...c], [])
    .forEach((s) => {
      const translation = {
        signatoryId: s.id,
        firstName: s.firstName,
        middleName: s.middleName,
        lastName: s.lastName,
        email: s.email,
        phoneNumber: s.phoneNumber,
      };
      translatedPeople.push(translation);
    });

  return translatedPeople;
};
